import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { FiMic, FiMicOff, FiVolume2, FiVolumeX } from 'react-icons/fi';
import { theme } from '../theme';
import { useAuth } from '../context/AuthContext';
import { VoiceRoom, getVoiceConfig } from '../services/voice';

const Bar = styled.div`display:flex;gap:.4rem;flex-wrap:wrap;align-items:center;margin:.4rem 0;`;
const Btn = styled.button`display:inline-flex;align-items:center;gap:.35rem;cursor:pointer;background:none;
  border:1px solid ${({ $on }) => ($on ? '#ef4444' : theme.colors.border)};color:${({ $on }) => ($on ? '#ef4444' : theme.colors.textSecondary)};
  padding:.4rem .7rem;border-radius:${theme.radii.full};font-size:.78rem;font-weight:600;
  &:hover{color:${theme.colors.textPrimary};border-color:${theme.colors.borderHover};}`;
const Live = styled.span`color:#22c55e;font-size:.8rem;font-weight:700;`;

/* Barre de chat VOCAL réutilisable (salon de jeu / groupe / général). Le signaling passe par un
 * canal Nakama ÉPHÉMÈRE `channelName` (persist=false → hors historique). Masquée tant que le vocal
 * n'est pas activé côté serveur (/voice/config, dépend du TURN). Reuse services/voice.VoiceRoom. */
export default function VoiceBar({ channelName, label = 'le vocal' }) {
  const { auth } = useAuth();
  const [on, setOn] = useState(false);
  const [inVoice, setInVoice] = useState(false);
  const [mic, setMic] = useState(false);
  const [out, setOut] = useState(false);
  const [peers, setPeers] = useState(0);
  const vrRef = useRef(null);
  const chanRef = useRef(null);
  const iceRef = useRef([]);

  useEffect(() => { getVoiceConfig().then((c) => { setOn(!!c.enabled); iceRef.current = c.iceServers || []; }).catch(() => {}); }, []);
  useEffect(() => () => { if (vrRef.current) { try { if (vrRef.current._unsub) vrRef.current._unsub(); vrRef.current.stop(); } catch { /* */ } } }, []);

  const join = async () => {
    if (!on || inVoice || !channelName) return;
    const ch = await auth.joinChannel(channelName, 1, false);
    if (!ch) return;
    chanRef.current = ch.id;
    const selfId = (auth.session && auth.session.user_id) || 'me';
    const vr = new VoiceRoom({ selfId, iceServers: iceRef.current, sendSignal: (p) => auth.sendChat(chanRef.current, '', { vsig: p }) });
    vr.onPeers = (ids) => setPeers(ids.length);
    vr._unsub = auth.onChatMessage((m) => {
      if (m.channel_id !== chanRef.current) return;
      try { const c = typeof m.content === 'string' ? JSON.parse(m.content) : m.content; if (c && c.vsig) vr.onSignal(c.vsig); } catch { /* */ }
    });
    vrRef.current = vr;
    try { await vr.start(); setInVoice(true); } catch { vrRef.current = null; }
  };
  const leave = () => {
    if (vrRef.current) { try { if (vrRef.current._unsub) vrRef.current._unsub(); vrRef.current.stop(); } catch { /* */ } vrRef.current = null; }
    setInVoice(false); setPeers(0); setMic(false); setOut(false);
  };
  const toggleMic = () => { const b = !mic; setMic(b); if (vrRef.current) vrRef.current.muteMic(b); };
  const toggleOut = () => { const b = !out; setOut(b); if (vrRef.current) vrRef.current.muteOutput(b); };

  if (!on) return null;
  return (
    <Bar>
      {!inVoice ? (
        <Btn onClick={join}><FiMic /> Rejoindre {label}</Btn>
      ) : (
        <>
          <Live>🔊 {peers} en vocal</Live>
          <Btn $on={mic} onClick={toggleMic}>{mic ? <FiMicOff /> : <FiMic />} {mic ? 'Micro coupé' : 'Micro'}</Btn>
          <Btn $on={out} onClick={toggleOut}>{out ? <FiVolumeX /> : <FiVolume2 />} {out ? 'Son coupé' : 'Son'}</Btn>
          <Btn onClick={leave}>Quitter</Btn>
        </>
      )}
    </Bar>
  );
}
